import axios from 'axios'
import moment from "moment";

export default {
    accessControl() {
        let logSession = localStorage.getItem('log_session');
        if(!logSession || logSession == ''){
          //criar sessao
          this.createSystemSession();
        }
        else{
          let obj;
          obj = JSON.parse(logSession);
          let session_date = moment(obj.updated_at);
          let now = moment();
          let diff_minutes = now.diff(session_date, 'minutes');
          if(diff_minutes >= 180){
            this.createSystemSession();
          }
          else{
               axios.post(`${process.env.VUE_APP_API_HOST}/api/system_log_access_increment/${obj.id}`,{})
              .then( response => {
                localStorage.setItem('log_session', JSON.stringify(response.data));
              })
              .catch( error => {
                localStorage.setItem('log_session', '');
              }) 
          }
        }
    },
    createSystemSession(){
      axios.post(`${process.env.VUE_APP_API_HOST}/api/system_log_access_public`,{})
      .then( response => {
        localStorage.setItem('log_session', JSON.stringify(response.data));
      })
    },
    close(){
      // closeConnection
      let logSession = localStorage.getItem('log_session');

      if(logSession){
        let obj = JSON.parse(logSession);
        
        if(obj.id){
          axios.post(`${process.env.VUE_APP_API_HOST}/api/system_log_access_close/${obj.id}`,{})
          .then( response => {
            localStorage.setItem('log_session', '');
          })
          .catch( error => {
            localStorage.setItem('log_session', '');
          })
        }
      }
    }
}